import IdentitySvc from '../api/IdentitySvc';
import PartnerSvc from '../api/PartnerSvc';

/**
 * Check if account is eligible for SSO multi-user invites.
 *
 * Returns:
 * - hasSsoFeature: true when partner has "SSO enabled for All users" feature
 * - hasSsoConfigured: true when Statsig gate enabled AND account has at least one active OIDC provider
 *
 * Each check fails independently so one service outage does not affect the other.
 *
 * @param {string} partnerId - Partner ID
 * @param {boolean} statsigGateEnabled - Value from 'sso_invite_new_users' feature gate
 * @returns {Promise<{ hasSsoFeature: boolean, hasSsoConfigured: boolean }>}
 */
export const checkSsoInviteEnabled = async (partnerId, statsigGateEnabled) => {
  let hasSsoFeature = false;
  let hasSsoConfigured = false;

  try {
    const partnerFeaturesResponse = await PartnerSvc.getPartnerFeatures(partnerId);

    hasSsoFeature = partnerFeaturesResponse?.data?.features?.['PARTNER.FEATURE_SSO_FOR_ALL_USERS'] === 'T';
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[SSO Check] Error checking partner SSO feature:', error);
  }

  try {
    const oidcProvidersResponse = await IdentitySvc.getPartnerOidcProviders(partnerId);
    const hasActiveOidcProvider = oidcProvidersResponse?.data?.some((provider) => provider.enabled === true) ?? false;

    hasSsoConfigured = statsigGateEnabled && hasSsoFeature && hasActiveOidcProvider;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error('[SSO Check] Error checking OIDC providers:', error);
  }

  return { hasSsoFeature, hasSsoConfigured };
};
